module.exports = __webpack_public_path__ + "static/mockup_shawn_mendes-612144e8218aaaaaf1a4079cd2b2505a.jpg";